import React from "react";
import { IconFor, labelFor } from "@/lib/categories";

// One vivid colour pair per category (stable hash) — shown at real-photo size when no photo exists.
const PALETTE = [
  ["#1E2A44", "#FF6B5B"], ["#0F766E", "#5EEAD4"], ["#7C2D12", "#FDBA74"], ["#1D4ED8", "#93C5FD"],
  ["#9D174D", "#F9A8D4"], ["#3F6212", "#BEF264"], ["#6D28D9", "#C4B5FD"], ["#B45309", "#FDE68A"],
  ["#0E7490", "#A5F3FC"], ["#BE123C", "#FECDD3"], ["#334155", "#CBD5E1"], ["#15803D", "#86EFAC"],
];
export const categoryColors = (key = "") => {
  let h = 0;
  for (const c of String(key)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
};

export const CategoryAvatar = ({ category, className = "", showLabel = true, iconSize = 56 }) => {
  const Icon = IconFor(category);
  const [bg, fg] = categoryColors(category);
  return (
    <div className={`relative w-full h-full overflow-hidden grid place-items-center ${className}`}
      style={{ background: `radial-gradient(circle at 30% 25%, ${fg}55, transparent 60%), ${bg}` }}
      data-testid="category-avatar" aria-label={labelFor(category)}>
      <div className="absolute -right-6 -bottom-6 opacity-15" style={{ color: fg }}><Icon size={iconSize * 2.6} strokeWidth={1.2} /></div>
      <div className="relative flex flex-col items-center gap-2">
        <span className="grid place-items-center rounded-full" style={{ width: iconSize * 1.7, height: iconSize * 1.7, background: `${fg}33`, color: fg }}>
          <Icon size={iconSize} strokeWidth={1.8} />
        </span>
        {showLabel && <span className="text-sm font-bold tracking-wide text-white/90 px-3 text-center">{labelFor(category)}</span>}
      </div>
    </div>
  );
};
